module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Video interview service with a human face"}}')
  delete Component.options._Ctor
}
